<template>
  <div class="colloquial-main">
    <Header ref="head" :current="6" />

    <div class="colloquial-banner">
      <img @click="gotodown('buy')" class="banner" :src="getpath('colloquial/picture_1', '.png')" alt="">
      <img class="buy-button" :src="getpath('colloquial/buyButton', '.png')" alt="">
    </div>
    <img :src="getpath('colloquial/picture_2', '.png')" alt="">
    <img :src="getpath('colloquial/picture_3', '.png')" alt="">
    <img :src="getpath('colloquial/picture_4', '.png')" alt="">
    <div class="colloquial-content">
      <img class="up" :src="getpath('colloquial/picture_5', '.png')" alt="">
      <img class="down" @click="gotodown('stick')" :src="getpath('colloquial/downAPP', '.png')" alt="">
    </div>
    <img :src="getpath('colloquial/parameter', '.png')" alt="">
    <Footer :color="'#5DAFF9'" />
  </div>
</template>
<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
export default {
  components: {
    Header,
    Footer,
  },
  data () {
    return {
    };
  },
	mounted() {
		document.title = 'Uummii-儿童口语贴';
	},
  methods : {
    
		gotobuy(){
			// if(this.isWeiXin){
				window.location.href = 'weixin://dl/business/?t=hY3kHiv3DQl'
			// }else{
			// 	alert('请在微信中打开')
			// }
		}
  },
}
</script>
<style lang="scss" scoped>
.colloquial-main{
  width: 750px;
  margin: 0 auto;
  min-width: 414px;
  color: rgba(51, 51, 51, 1);
  padding-top: 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  > img{
    width: 100%;
  }
  .colloquial-banner{
    width: 100%;
    position: relative;
    .banner{
      width: 100%;
    }
    .buy-button{
      width: 195px;
      height: 62px;
      position: absolute;
      left: 478px;
      bottom: 62px;
    }
  }
  .colloquial-content{
    width: 100%;
    position: relative;
    .up{
      width: 100%;
      margin-top: -89px;
    }
    .down{
      width: 407px;
      height: 186px;
      position: absolute;
      top: 297px;
      left: 169px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/colloquial.vue